// frontend/src/inicios/UserDashboardInicio.js
import React from 'react';
import './UserDashboardInicio.css'; // Importamos los estilos desde la misma carpeta
import {
    Row, Col, Card, Button, ProgressBar, Table, Badge, Spinner
} from 'react-bootstrap';
import {
  FaHome,
  FaFileInvoiceDollar,
  FaBell,
  FaChartLine,
  FaCalendarAlt,
} from 'react-icons/fa';

const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || isNaN(Number(amount))) return '$0.00';
    const numAmount = Number(amount);
    return `$${numAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
};

const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
        const date = new Date(dateString);
        if (dateString.length === 10 && dateString.includes('-')) {
           const parts = dateString.split('-');
           const utcDate = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
           if (isNaN(utcDate.getTime())) return 'Fecha inválida';
           return utcDate.toLocaleDateString('es-EC', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
        }
        if (isNaN(date.getTime())) return 'Fecha inválida';
        return date.toLocaleDateString('es-EC', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch (e) {
        return "Fecha inválida";
    }
};

function UserDashboardInicio({ userInfo, notificaciones, pagos, stats, loading, setActiveSection }) {
  return (
    <div className="dashboard-inicio-section">
      <div className="inicio-welcome-banner">
        <Row className="align-items-center">
          <Col>
            <h2>Bienvenido de nuevo, {userInfo.nombre}</h2>
            <p className="mb-0">Aquí tienes el resumen de tu cuenta y los avisos más recientes.</p>
          </Col>
          <Col md="auto" className="d-none d-md-block mt-3 mt-md-0">
            <div className="inicio-date-display d-flex align-items-center">
              <FaCalendarAlt className="me-2" />
              <span>{new Date().toLocaleDateString('es-EC', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
            </div>
          </Col>
        </Row>
      </div>

      <Row className="mb-4">
        <Col md={6} lg={3} className="mb-4">
            <Card className="info-card-inicio apartment h-100">
                <Card.Body className="d-flex align-items-center">
                    <div className="card-icon-wrapper me-3"><FaHome /></div>
                    <div>
                        <h3>Apartamento</h3>
                        <p>{userInfo.apartamento}</p>
                    </div>
                </Card.Body>
            </Card>
        </Col>
        <Col md={6} lg={3} className="mb-4">
            <Card className="info-card-inicio balance h-100">
               <Card.Body>
                  <div className="d-flex align-items-center">
                      <div className="card-icon-wrapper me-3"><FaFileInvoiceDollar /></div>
                      <div>
                          <h3>Saldo Pendiente</h3>
                          <p>{userInfo.saldoPendiente}</p>
                      </div>
                  </div>
                  <Button variant="link" className="card-action-link" onClick={() => setActiveSection('pagos')}>Ver Pagos</Button>
               </Card.Body>
            </Card>
        </Col>
         <Col md={6} lg={3} className="mb-4">
            <Card className="info-card-inicio notices h-100">
               <Card.Body>
                  <div className="d-flex align-items-center">
                      <div className="card-icon-wrapper me-3"><FaBell /></div>
                      <div>
                          <h3>Avisos Nuevos</h3>
                          <p>{notificaciones.length}</p>
                      </div>
                  </div>
                  <Button variant="link" className="card-action-link" onClick={() => setActiveSection('avisos')}>Ver Avisos</Button>
               </Card.Body>
            </Card>
        </Col>
         <Col md={6} lg={3} className="mb-4">
            <Card className="info-card-inicio progress h-100">
               <Card.Body>
                   <div className="d-flex align-items-center">
                       <div className="card-icon-wrapper me-3"><FaChartLine /></div>
                       <div>
                           <h3>Progreso Pagos</h3>
                           <p>{stats.progreso}%</p>
                       </div>
                   </div>
                   <ProgressBar now={stats.progreso} variant="success" style={{ height: '6px', position:'absolute', bottom:0, left:0, width: '100%', borderRadius: 0 }}/>
               </Card.Body>
            </Card>
        </Col>
      </Row>

      <Row>
        <Col lg={6} className="mb-4">
            <Card className="widget-card-inicio h-100">
                <Card.Header className="d-flex justify-content-between align-items-center">
                   <h3>Avisos Recientes</h3>
                   <Button variant="link" size="sm" onClick={() => setActiveSection('avisos')}>Ver todos</Button>
                </Card.Header>
               <Card.Body>
                 {loading && notificaciones.length === 0 ? <div className="text-center p-4"><Spinner animation="border" size="sm" /></div> :
                  notificaciones.length === 0 ? <p className="text-muted text-center p-4">No hay avisos por el momento.</p> :
                  notificaciones.slice(0, 2).map(n => (
                    <div key={n.id} className="notice-item-inicio border-bottom">
                       <div className="d-flex justify-content-between">
                           <h6 className="mb-1 fw-bold">{n.titulo}</h6>
                           <small className="text-muted">{n.fecha}</small>
                       </div>
                       <p className="text-muted small mb-0">{n.descripcion.substring(0, 120)}{n.descripcion.length > 120 ? '...' : ''}</p>
                     </div>
                   ))}
                </Card.Body>
            </Card>
        </Col>
         <Col lg={6} className="mb-4">
            <Card className="widget-card-inicio h-100">
                <Card.Header className="d-flex justify-content-between align-items-center">
                   <h3>Resumen de Pagos</h3>
                   <Button variant="link" size="sm" onClick={() => setActiveSection('pagos')}>Ver historial</Button>
                </Card.Header>
               <Card.Body>
                  {loading && pagos.length === 0 ? <div className="text-center p-4"><Spinner animation="border" size="sm" /></div> :
                   pagos.length === 0 ? <p className="text-muted text-center p-4">¡Estás al día! No hay pagos registrados.</p> :
                   (
                     <>
                       <Row className="text-center mb-4">
                         <Col>
                           <small className="text-muted d-block">Último Pago Realizado</small>
                           <span className="fw-bold fs-6">{userInfo.ultimoPago}</span>
                         </Col>
                         <Col className="border-start">
                           <small className="text-muted d-block">Saldo Pendiente Total</small>
                           <span className="fw-bold fs-5 text-danger">{userInfo.saldoPendiente}</span>
                         </Col>
                       </Row>
                       <Table hover responsive className="summary-table mb-0">
                           <tbody>
                               {pagos.slice(0, 3).map(p => (
                                   <tr key={`summary-${p.id}`}>
                                       <td>{p.concept}</td>
                                       <td className="text-end fw-bold">{formatCurrency(p.amount)}</td>
                                       <td className="text-end">
                                            <Badge
                                               pill
                                               bg={p.estado === 'Pagado' ? 'success' : p.estado === 'Pendiente de validación' ? 'warning' : 'danger'}
                                               text={p.estado === 'Pendiente de validación' ? 'dark' : 'white'}
                                             >
                                               {p.estado}
                                             </Badge>
                                       </td>
                                   </tr>
                               ))}
                           </tbody>
                       </Table>
                     </>
                   )
                  }
                </Card.Body>
            </Card>
        </Col>
      </Row>
    </div>
  );
}

export default UserDashboardInicio;